import type { Icon } from '../../../src/lib/types'
export const mdiFormatIndentIncrease: Icon = {
  "id": "format-indent-increase",
  "name": "Format Indent Increase",
  "path": "M11,13H21V11H11M11,9H21V7H11M3,3V5H21V3M11,17H21V15H11M3,8V16L7,12M3,21H21V19H3V21Z",
  "as": [],
  "tags": [
    "Text / Content / Format"
  ]
}
export default mdiFormatIndentIncrease